import React from 'react';
import MkIcon from '../MkIcon';
import bestappBadge from '../../../assets/images/mk/mk-bestapp-badge-240.webp';
import updatestarBadge from '../../../assets/images/mk/mk-updatestar-4stars-118.webp';
import { BESTAPP_URL, UPDATESTAR_URL } from '../../../marketing/links';
import { PLAY_FACTS } from '../../../marketing/facts';
import { mkTrack } from '../../../marketing/track';

// H2 — dated, attributed proof. Every number here is Keep Me Out's, from its public Play listing.
const STATS = [
  { num: PLAY_FACTS.downloads, label: 'downloads' },
  { num: PLAY_FACTS.ratings, label: 'ratings' },
  { num: PLAY_FACTS.highRatings, label: 'four- and five-star ratings' },
  { num: PLAY_FACTS.since, label: 'on Google Play since' },
];

const HomeProof = () => (
  <section className="mk-proof section" id="proof" aria-labelledby="mk-proof-title">
    <div className="container">
      <div className="mk-proof__inner section-inner">
        <h2 id="mk-proof-title" className="mk-eyebrow mk-proof__title">
          Keep Me Out on Google Play
        </h2>
        <div className="mk-proof__grid">
          <div className="mk-proof__stats reveal-from-bottom">
            <div className="mk-card mk-proof__panel">
              <dl className="mk-proof__dl">
                {STATS.map((s) => (
                  <div className="mk-proof__stat" key={s.label}>
                    <dt>{s.label}</dt>
                    <dd className="mk-stat__num">{s.num}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
        {/* Awards get their own full-width row — two third-party seals, each linking to its source. */}
        <h3 className="mk-eyebrow mk-proof__awards-title">Awards</h3>
        <div className="mk-proof__awards">
          <a
            className="mk-card mk-award reveal-scale-up"
            href={BESTAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => mkTrack('outbound_click', 'bestapp:home_proof')}
          >
            <img
              className="mk-award__badge"
              src={bestappBadge}
              width={96}
              height={106}
              loading="lazy"
              decoding="async"
              alt=""
            />
            <span className="mk-award__text">
              <span className="mk-award__from">BestApp.com</span>
              <span className="mk-award__title">“Best for Device Locking”</span>
              <span className="mk-award__body">
                Named in its list of the best apps to curb smartphone addiction.
              </span>
              <span className="mk-award__link">
                Read the article
                <MkIcon name="arrow-right" size={16} />
                <span className="screen-reader"> (opens in a new tab)</span>
              </span>
            </span>
          </a>
          <a
            className="mk-card mk-award reveal-scale-up"
            data-reveal-delay="120"
            href={UPDATESTAR_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => mkTrack('outbound_click', 'updatestar:home_proof')}
          >
            <img
              className="mk-award__badge mk-award__badge--seal"
              src={updatestarBadge}
              width={118}
              height={96}
              loading="lazy"
              decoding="async"
              alt=""
            />
            <span className="mk-award__text">
              <span className="mk-award__from">UpdateStar</span>
              <span className="mk-award__title">“Very Good” award</span>
              <span className="mk-award__body">
                “Keep Me Out - Phone lock is an outstanding product and was given the ‘Very Good’ award by its users.”
                <span className="mk-award__who">— Michael Ganss, UpdateStar.com</span>
              </span>
              <span className="mk-award__link">
                See the listing
                <MkIcon name="arrow-right" size={16} />
                <span className="screen-reader"> (opens in a new tab)</span>
              </span>
            </span>
          </a>
        </div>
        <ul className="list-reset mk-proof__chips">
          <li className="reveal-from-bottom" data-reveal-delay="80">
            <span className="mk-chip">
              <MkIcon name="globe" size={18} />
              {`Available in ${PLAY_FACTS.languages} languages`}
            </span>
          </li>
          <li className="reveal-from-bottom" data-reveal-delay="160">
            <span className="mk-chip">
              <MkIcon name="pin" size={18} />
              Made in Germany by eudaiTec GmbH, Berlin
            </span>
          </li>
        </ul>
        <p className="mk-micro mk-proof__foot">
          {`Figures from Keep Me Out's public Google Play listing, ${PLAY_FACTS.asOfLong}. Star ratings vary by country. UpdateStar's award reflects its own listing's user rating of 4 out of 5.`}
        </p>
      </div>
    </div>
  </section>
);

export default HomeProof;
